var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.07,
    height: 4.744
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_svgr__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.07v4.744H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_svgr__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.535 4.744L.003 1.207 1.209 0l2.327 2.327L5.866 0l1.207 1.207-3.536 3.537z"
  }))));
};

export default SvgArrow;